"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var storeApi = _interopRequireWildcard(require("@/api/store"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      visible: false,
      maxNum: 1,
      maxPage: 1,
      inputNum: 1,
      listPram: {}
    };
  },
  mounted: function mounted() {},
  methods: {
    openInit: function openInit() {
      var listPram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var maxNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.listPram = listPram;
      this.inputNum = 1;
      this.maxNum = maxNum;
      this.maxPage = Math.ceil(Number(Number(maxNum) / 10000));
      this.visible = true;
    },
    handerSubmit: function handerSubmit() {
      var _this = this;
      if (!this.inputNum) {
        this.$message.warning('请输入导出页码！');
        return;
      }
      ;
      storeApi.exportJdGoods(this.listPram, this.inputNum).then(function (res) {
        window.open(res.fileName);
        _this.visible = false;
      });
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    }
  }
};